import React, { useState } from "react";
import { Panel } from "rsuite";
import styled, { css } from "styled-components";


type StyledPanelProps = {
    $noStyles?: boolean;
    $noEndPadding?: boolean;
    selfExpanded?: boolean;
    expanded?: boolean;
};

const StyledPanel = styled(Panel)<StyledPanelProps>`
    && {
        overflow: visible;

        .rs-panel-header .rs-panel-btn:hover,
        .rs-panel-header .rs-panel-btn:focus,
        .rs-panel-header .rs-panel-btn:active {
            ${props => props.selfExpanded ? css`
                cursor: default;
                background-color: #1f2937;
            ` : css`
                background-color: #374151;
            `}
        }

        .rs-panel-header {
            ${props => props.expanded ? css`
                margin-bottom: 0;
                transition: margin-bottom 0.2s;
            ` : css`
                margin-bottom: 0;
                transition: margin-bottom 0.2s;
            `}
        }

        .rs-panel-header .rs-panel-btn .rs-panel-btn-icon {
            ${props => !props.selfExpanded ? css`
                display: none;
            ` : css`
                color: #fff;
            `}
        }

        .rs-panel-header .rs-panel-title {
            color: #fff;
            font-weight: 600;
            font-size: 1.25rem;
        }
    }

    ${props => !props.$noStyles ? css`
        && {
            background-color: #1f2937;
            color: #fff;
            padding: 1.5rem;
            border-radius: 0.75rem;
            box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
            border: 1px solid #374151;
            border-radius: 0.75rem;

            .rs-panel-header {
                padding: 10px;
            }

            :not(:nth-last-child()) {
                margin-bottom: 1.5rem;
            }
        }
    ` : css`
        && {
            .rs-panel-body {
                ${props.$noEndPadding ? css`
                    padding-top: 0px;
                    padding-bottom: 0;
                    padding-left: 0;
                    padding-right: 0;
                ` : css`
                    padding: 0px 0;
                `}
            }

            .rs-panel-header {
                padding: 0 0;
            }
        }
    `}
`;


type BasePanelProps = {
    children: React.ReactNode;
    header?: string;
    defaultExpanded?: boolean;
    expanded?: boolean;
    selfExpanded?: boolean;
    noStyles?: boolean;
    noEndPadding?: boolean;
};

const MyPanel: React.FC<BasePanelProps> = ({ children, header, defaultExpanded, expanded, selfExpanded, noStyles = false, noEndPadding = false, ...props }) => {
    const [isCollapsible] = useState(expanded !== undefined || selfExpanded || false);
    const [isExpanded, setIsExpanded] = useState(selfExpanded || false);

    return <StyledPanel
        collapsible={isCollapsible}
        defaultExpanded={true}
        selfExpanded={selfExpanded}
        $noStyles={noStyles}
        $noEndPadding={noEndPadding}
        {...(!selfExpanded
            ? { expanded }
            : {
                expanded: isExpanded,
                onSelect: () => {
                    setIsExpanded((prev) => !prev);
                }
            }
        )}
        {...(header ? { header } : {})}
        {...props}
    >
        {children}
    </StyledPanel >;
};

export default MyPanel;